var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 2",
    d: "M16.667 20H0V0h16.667v20zM6.172 12.182h4.347l.969 2.755h1.862L9.3 4.166H7.38L3.334 14.937H5.2l.976-2.754zm3.778-1.561H6.734L8.3 6.167h.093l1.556 4.453z",
    transform: "translate(1.666)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21930"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19907",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgColor);
export default __webpack_public_path__ + "static/media/bg-color.a4c4fca2f040dc2c0149c465f5aff24d.svg";
export { ForwardRef as ReactComponent };